export const ALLOWED_CREATOR_ORDER_BY_VALUES = [
  '',
  'relevance',
  'created_at',
  'first_name',
  'last_name',
  'email',
  'name',
  'date_of_birth',
  'updated_at',
  'location.city',
  'location.country',
  'location.country_code',
  'gender_agency',
  'total_audience',
  'platforms.instagram.followers_count',
  'platforms.instagram.follows_count',
  'platforms.instagram.media_count',
  'platforms.instagram.engagement_rate',
  'platforms.tiktok.followers_count',
  'platforms.tiktok.videos_count',
  'platforms.tiktok.likes_count',
  'platforms.youtube.published_at',
  'platforms.youtube.view_count',
  'platforms.youtube.comment_count',
  'platforms.youtube.followers_count',
  'platforms.youtube.video_count',
  'demographics.instagram.ages._13-17',
  'demographics.instagram.ages._18-24',
  'demographics.instagram.ages._25-34',
  'demographics.instagram.ages._35-44',
  'demographics.instagram.ages._45-64',
  'demographics.instagram.ages._65+',
  'demographics.instagram.genders.male',
  'demographics.instagram.genders.female',
  'demographics.tiktok.ages._18-24',
  'demographics.tiktok.ages._25-34',
  'demographics.tiktok.ages._35+',
  'demographics.tiktok.genders.female',
  'demographics.tiktok.genders.male',
  'demographics.tiktok.genders.other',
  'demographics.tiktok.average_comments',
  'demographics.tiktok.average_likes',
  'demographics.tiktok.average_shares',
  'demographics.tiktok.average_views',
  'demographics.tiktok.completion_rate',
  'demographics.tiktok.engagement_rate',
  'demographics.tiktok.followers_growth_rate',
  'demographics.youtube.ages._13-17',
  'demographics.youtube.ages._18-24',
  'demographics.youtube.ages._25-34',
  'demographics.youtube.ages._35-44',
  'demographics.youtube.ages._45-54',
  'demographics.youtube.ages._55-64',
  'demographics.youtube.ages._65+',
  'demographics.youtube.genders.female',
  'demographics.youtube.genders.male',
  'demographics.youtube.genders.other',
  'benchmarks.instagram.ig_avg_feed_comments',
  'benchmarks.instagram.ig_avg_feed_engagements',
  'benchmarks.instagram.ig_avg_feed_followers',
  'benchmarks.instagram.ig_avg_feed_follower_eng_rate',
  'benchmarks.instagram.ig_avg_feed_impressions',
  'benchmarks.instagram.ig_avg_feed_likes',
  'benchmarks.instagram.ig_avg_feed_reach',
  'benchmarks.instagram.ig_avg_feed_reach_eng_rate',
  'benchmarks.instagram.ig_avg_feed_saved',
  'benchmarks.instagram.ig_avg_image_comments',
  'benchmarks.instagram.ig_avg_image_engagements',
  'benchmarks.instagram.ig_avg_image_followers',
  'benchmarks.instagram.ig_avg_image_followers_eng_rate',
  'benchmarks.instagram.ig_avg_image_impressions',
  'benchmarks.instagram.ig_avg_image_likes',
  'benchmarks.instagram.ig_avg_image_reach',
  'benchmarks.instagram.ig_avg_image_reach_eng_rate',
  'benchmarks.instagram.ig_avg_image_saved',
  'benchmarks.instagram.ig_avg_reels_engagements',
  'benchmarks.instagram.ig_avg_reels_followers_eng_rate',
  'benchmarks.instagram.ig_avg_reels_followers_interactions_rate',
  'benchmarks.instagram.ig_avg_reels_interactions',
  'benchmarks.instagram.ig_avg_reels_likes',
  'benchmarks.instagram.ig_avg_reels_plays',
  'benchmarks.instagram.ig_avg_reels_plays_eng_rate',
  'benchmarks.instagram.ig_avg_reels_plays_interactions_rate',
  'benchmarks.instagram.ig_avg_reels_reach',
  'benchmarks.instagram.ig_avg_reels_reach_eng_rate',
  'benchmarks.instagram.ig_avg_reels_reach_interactions_rate',
  'benchmarks.instagram.ig_avg_reels_saved',
  'benchmarks.instagram.ig_avg_reels_shared',
  'benchmarks.instagram.ig_avg_story_exits',
  'benchmarks.instagram.ig_avg_story_followers',
  'benchmarks.instagram.ig_avg_story_followers_reach_rate',
  'benchmarks.instagram.ig_avg_story_frame_completion_rate',
  'benchmarks.instagram.ig_avg_story_impressions',
  'benchmarks.instagram.ig_avg_story_reach',
  'benchmarks.instagram.ig_avg_story_replies',
  'benchmarks.instagram.ig_avg_story_taps_back',
  'benchmarks.instagram.ig_avg_story_taps_forward',
  'benchmarks.instagram.ig_avg_video_comments',
  'benchmarks.instagram.ig_avg_video_engagements',
  'benchmarks.instagram.ig_avg_video_followers',
  'benchmarks.instagram.ig_avg_video_followers_eng_rate',
  'benchmarks.instagram.ig_avg_video_likes',
  'benchmarks.instagram.ig_avg_video_reach',
  'benchmarks.instagram.ig_avg_video_reach_eng_rate',
  'benchmarks.instagram.ig_avg_video_reach_video_views_rate',
  'benchmarks.instagram.ig_avg_video_saved',
  'benchmarks.instagram.ig_avg_video_views',
  'benchmarks.youtube.yt_avg_comments',
  'benchmarks.youtube.yt_avg_engagements',
  'benchmarks.youtube.yt_avg_likes',
  'benchmarks.youtube.yt_avg_shares',
  'benchmarks.youtube.yt_avg_subscribers_eng_rate',
  'benchmarks.youtube.yt_avg_views',
  'benchmarks.youtube.yt_avg_views_eng_rate',
  'benchmarks.youtube.yt_avg_view_rate',
];

export const ALLOWED_CREATOR_FILTER_NAMES = [
  'benchmarks.instagram.ig_avg_feed_comments',
  'benchmarks.instagram.ig_avg_feed_engagements',
  'benchmarks.instagram.ig_avg_feed_followers',
  'benchmarks.instagram.ig_avg_feed_follower_eng_rate',
  'benchmarks.instagram.ig_avg_feed_impressions',
  'benchmarks.instagram.ig_avg_feed_likes',
  'benchmarks.instagram.ig_avg_feed_reach',
  'benchmarks.instagram.ig_avg_feed_reach_eng_rate',
  'benchmarks.instagram.ig_avg_feed_saved',
  'benchmarks.instagram.ig_avg_image_comments',
  'benchmarks.instagram.ig_avg_image_engagements',
  'benchmarks.instagram.ig_avg_image_followers',
  'benchmarks.instagram.ig_avg_image_followers_eng_rate',
  'benchmarks.instagram.ig_avg_image_impressions',
  'benchmarks.instagram.ig_avg_image_likes',
  'benchmarks.instagram.ig_avg_image_reach',
  'benchmarks.instagram.ig_avg_image_reach_eng_rate',
  'benchmarks.instagram.ig_avg_image_saved',
  'benchmarks.instagram.ig_avg_reels_engagements',
  'benchmarks.instagram.ig_avg_reels_followers_eng_rate',
  'benchmarks.instagram.ig_avg_reels_followers_interactions_rate',
  'benchmarks.instagram.ig_avg_reels_interactions',
  'benchmarks.instagram.ig_avg_reels_likes',
  'benchmarks.instagram.ig_avg_reels_plays',
  'benchmarks.instagram.ig_avg_reels_plays_eng_rate',
  'benchmarks.instagram.ig_avg_reels_plays_interactions_rate',
  'benchmarks.instagram.ig_avg_reels_reach',
  'benchmarks.instagram.ig_avg_reels_reach_eng_rate',
  'benchmarks.instagram.ig_avg_reels_reach_interactions_rate',
  'benchmarks.instagram.ig_avg_reels_saved',
  'benchmarks.instagram.ig_avg_reels_shared',
  'benchmarks.instagram.ig_avg_story_exits',
  'benchmarks.instagram.ig_avg_story_followers',
  'benchmarks.instagram.ig_avg_story_followers_reach_rate',
  'benchmarks.instagram.ig_avg_story_frame_completion_rate',
  'benchmarks.instagram.ig_avg_story_impressions',
  'benchmarks.instagram.ig_avg_story_reach',
  'benchmarks.instagram.ig_avg_story_replies',
  'benchmarks.instagram.ig_avg_story_taps_back',
  'benchmarks.instagram.ig_avg_story_taps_forward',
  'benchmarks.instagram.ig_avg_video_comments',
  'benchmarks.instagram.ig_avg_video_engagements',
  'benchmarks.instagram.ig_avg_video_followers',
  'benchmarks.instagram.ig_avg_video_followers_eng_rate',
  'benchmarks.instagram.ig_avg_video_likes',
  'benchmarks.instagram.ig_avg_video_reach',
  'benchmarks.instagram.ig_avg_video_reach_eng_rate',
  'benchmarks.instagram.ig_avg_video_reach_video_views_rate',
  'benchmarks.instagram.ig_avg_video_saved',
  'benchmarks.instagram.ig_avg_video_views',
  'benchmarks.youtube.yt_avg_comments',
  'benchmarks.youtube.yt_avg_engagements',
  'benchmarks.youtube.yt_avg_likes',
  'benchmarks.youtube.yt_avg_shares',
  'benchmarks.youtube.yt_avg_subscribers_eng_rate',
  'benchmarks.youtube.yt_avg_views',
  'benchmarks.youtube.yt_avg_views_eng_rate',
  'benchmarks.youtube.yt_avg_view_rate',
  'category_agency',
  'category_tags',
  'date_of_birth',
  'demographics.instagram.ages._13-17',
  'demographics.instagram.ages._18-24',
  'demographics.instagram.ages._25-34',
  'demographics.instagram.ages._35-44',
  'demographics.instagram.ages._45-64',
  'demographics.instagram.ages._65+',
  'demographics.instagram.genders.female',
  'demographics.instagram.genders.male',
  'demographics.tiktok.ages._18-24',
  'demographics.tiktok.ages._25-34',
  'demographics.tiktok.ages._35+',
  'demographics.tiktok.average_comments',
  'demographics.tiktok.average_likes',
  'demographics.tiktok.average_shares',
  'demographics.tiktok.average_views',
  'demographics.tiktok.completion_rate',
  'demographics.tiktok.engagement_rate',
  'demographics.tiktok.followers_growth_rate',
  'demographics.tiktok.genders.female',
  'demographics.tiktok.genders.male',
  'demographics.tiktok.genders.other',
  'demographics.youtube.ages._13-17',
  'demographics.youtube.ages._18-24',
  'demographics.youtube.ages._25-34',
  'demographics.youtube.ages._35-44',
  'demographics.youtube.ages._45-54',
  'demographics.youtube.ages._55-64',
  'demographics.youtube.ages._65+',
  'demographics.youtube.genders.female',
  'demographics.youtube.genders.male',
  'demographics.youtube.genders.other',
  'email',
  'first_name',
  'gender_agency',
  'id',
  'ig_status',
  'is_off_platform',
  'last_name',
  'location.city',
  'location.country',
  'location.country_code',
  'location.geo',
  'name',
  'off_platform_is_visible',
  'platforms.instagram.category',
  'platforms.instagram.engagement_rate',
  'platforms.instagram.followers_count',
  'platforms.instagram.follows_count',
  'platforms.instagram.handle',
  'platforms.instagram.has_account',
  'platforms.instagram.media_count',
  'platforms.instagram.status',
  'platforms.snapchat.followers_count',
  'platforms.snapchat.is_connected',
  'platforms.snapchat.status',
  'platforms.snapchat.username',
  'platforms.tiktok.connected',
  'platforms.tiktok.display_name',
  'platforms.tiktok.followers_count',
  'platforms.tiktok.handle',
  'platforms.tiktok.has_account',
  'platforms.tiktok.likes_count',
  'platforms.tiktok.status',
  'platforms.tiktok.videos_count',
  'platforms.youtube.comment_count',
  'platforms.youtube.connected',
  'platforms.youtube.followers_count',
  'platforms.youtube.has_account',
  'platforms.youtube.name',
  'platforms.youtube.published_at',
  'platforms.youtube.status',
  'platforms.youtube.video_count',
  'platforms.youtube.view_count',
  'platforms.youtube.yt_channel_id',
  'snp_status',
  'total_audience',
  'tt_status',
  'updated_at',
  'yt_status',
  'demographics.instagram.countries:iso.AF',
  'demographics.instagram.countries:iso.AX',
  'demographics.instagram.countries:iso.AL',
  'demographics.instagram.countries:iso.DZ',
  'demographics.instagram.countries:iso.AS',
  'demographics.instagram.countries:iso.AD',
  'demographics.instagram.countries:iso.AO',
  'demographics.instagram.countries:iso.AI',
  'demographics.instagram.countries:iso.AQ',
  'demographics.instagram.countries:iso.AG',
  'demographics.instagram.countries:iso.AR',
  'demographics.instagram.countries:iso.AM',
  'demographics.instagram.countries:iso.AW',
  'demographics.instagram.countries:iso.AU',
  'demographics.instagram.countries:iso.AT',
  'demographics.instagram.countries:iso.AZ',
  'demographics.instagram.countries:iso.BS',
  'demographics.instagram.countries:iso.BH',
  'demographics.instagram.countries:iso.BD',
  'demographics.instagram.countries:iso.BB',
  'demographics.instagram.countries:iso.BY',
  'demographics.instagram.countries:iso.BE',
  'demographics.instagram.countries:iso.BZ',
  'demographics.instagram.countries:iso.BJ',
  'demographics.instagram.countries:iso.BM',
  'demographics.instagram.countries:iso.BT',
  'demographics.instagram.countries:iso.BO',
  'demographics.instagram.countries:iso.BQ',
  'demographics.instagram.countries:iso.BA',
  'demographics.instagram.countries:iso.BW',
  'demographics.instagram.countries:iso.BV',
  'demographics.instagram.countries:iso.BR',
  'demographics.instagram.countries:iso.IO',
  'demographics.instagram.countries:iso.BN',
  'demographics.instagram.countries:iso.BG',
  'demographics.instagram.countries:iso.BF',
  'demographics.instagram.countries:iso.BI',
  'demographics.instagram.countries:iso.KH',
  'demographics.instagram.countries:iso.CM',
  'demographics.instagram.countries:iso.CA',
  'demographics.instagram.countries:iso.CV',
  'demographics.instagram.countries:iso.KY',
  'demographics.instagram.countries:iso.CF',
  'demographics.instagram.countries:iso.TD',
  'demographics.instagram.countries:iso.CL',
  'demographics.instagram.countries:iso.CN',
  'demographics.instagram.countries:iso.CX',
  'demographics.instagram.countries:iso.CC',
  'demographics.instagram.countries:iso.CO',
  'demographics.instagram.countries:iso.KM',
  'demographics.instagram.countries:iso.CG',
  'demographics.instagram.countries:iso.CD',
  'demographics.instagram.countries:iso.CK',
  'demographics.instagram.countries:iso.CR',
  'demographics.instagram.countries:iso.HR',
  'demographics.instagram.countries:iso.CU',
  'demographics.instagram.countries:iso.CW',
  'demographics.instagram.countries:iso.CY',
  'demographics.instagram.countries:iso.CZ',
  'demographics.instagram.countries:iso.DK',
  'demographics.instagram.countries:iso.DJ',
  'demographics.instagram.countries:iso.DM',
  'demographics.instagram.countries:iso.DO',
  'demographics.instagram.countries:iso.EC',
  'demographics.instagram.countries:iso.EG',
  'demographics.instagram.countries:iso.SV',
  'demographics.instagram.countries:iso.GQ',
  'demographics.instagram.countries:iso.ER',
  'demographics.instagram.countries:iso.EE',
  'demographics.instagram.countries:iso.ET',
  'demographics.instagram.countries:iso.FK',
  'demographics.instagram.countries:iso.FO',
  'demographics.instagram.countries:iso.FJ',
  'demographics.instagram.countries:iso.FI',
  'demographics.instagram.countries:iso.FR',
  'demographics.instagram.countries:iso.GF',
  'demographics.instagram.countries:iso.PF',
  'demographics.instagram.countries:iso.TF',
  'demographics.instagram.countries:iso.GA',
  'demographics.instagram.countries:iso.GM',
  'demographics.instagram.countries:iso.GE',
  'demographics.instagram.countries:iso.DE',
  'demographics.instagram.countries:iso.GH',
  'demographics.instagram.countries:iso.GI',
  'demographics.instagram.countries:iso.GR',
  'demographics.instagram.countries:iso.GL',
  'demographics.instagram.countries:iso.GD',
  'demographics.instagram.countries:iso.GP',
  'demographics.instagram.countries:iso.GU',
  'demographics.instagram.countries:iso.GT',
  'demographics.instagram.countries:iso.GG',
  'demographics.instagram.countries:iso.GN',
  'demographics.instagram.countries:iso.GW',
  'demographics.instagram.countries:iso.GY',
  'demographics.instagram.countries:iso.HT',
  'demographics.instagram.countries:iso.HM',
  'demographics.instagram.countries:iso.VA',
  'demographics.instagram.countries:iso.HN',
  'demographics.instagram.countries:iso.HK',
  'demographics.instagram.countries:iso.HU',
  'demographics.instagram.countries:iso.IS',
  'demographics.instagram.countries:iso.IN',
  'demographics.instagram.countries:iso.ID',
  'demographics.instagram.countries:iso.IR',
  'demographics.instagram.countries:iso.IQ',
  'demographics.instagram.countries:iso.IE',
  'demographics.instagram.countries:iso.IM',
  'demographics.instagram.countries:iso.IL',
  'demographics.instagram.countries:iso.IT',
  'demographics.instagram.countries:iso.CI',
  'demographics.instagram.countries:iso.JM',
  'demographics.instagram.countries:iso.JP',
  'demographics.instagram.countries:iso.JE',
  'demographics.instagram.countries:iso.JO',
  'demographics.instagram.countries:iso.KZ',
  'demographics.instagram.countries:iso.KE',
  'demographics.instagram.countries:iso.KI',
  'demographics.instagram.countries:iso.KW',
  'demographics.instagram.countries:iso.KG',
  'demographics.instagram.countries:iso.LA',
  'demographics.instagram.countries:iso.LV',
  'demographics.instagram.countries:iso.LB',
  'demographics.instagram.countries:iso.LS',
  'demographics.instagram.countries:iso.LR',
  'demographics.instagram.countries:iso.LY',
  'demographics.instagram.countries:iso.LI',
  'demographics.instagram.countries:iso.LT',
  'demographics.instagram.countries:iso.LU',
  'demographics.instagram.countries:iso.MO',
  'demographics.instagram.countries:iso.MK',
  'demographics.instagram.countries:iso.MG',
  'demographics.instagram.countries:iso.MW',
  'demographics.instagram.countries:iso.MY',
  'demographics.instagram.countries:iso.MV',
  'demographics.instagram.countries:iso.ML',
  'demographics.instagram.countries:iso.MT',
  'demographics.instagram.countries:iso.MH',
  'demographics.instagram.countries:iso.MQ',
  'demographics.instagram.countries:iso.MR',
  'demographics.instagram.countries:iso.MU',
  'demographics.instagram.countries:iso.YT',
  'demographics.instagram.countries:iso.MX',
  'demographics.instagram.countries:iso.FM',
  'demographics.instagram.countries:iso.MD',
  'demographics.instagram.countries:iso.MC',
  'demographics.instagram.countries:iso.MN',
  'demographics.instagram.countries:iso.ME',
  'demographics.instagram.countries:iso.MS',
  'demographics.instagram.countries:iso.MA',
  'demographics.instagram.countries:iso.MZ',
  'demographics.instagram.countries:iso.MM',
  'demographics.instagram.countries:iso.NA',
  'demographics.instagram.countries:iso.NR',
  'demographics.instagram.countries:iso.NP',
  'demographics.instagram.countries:iso.NL',
  'demographics.instagram.countries:iso.NC',
  'demographics.instagram.countries:iso.NZ',
  'demographics.instagram.countries:iso.NI',
  'demographics.instagram.countries:iso.NE',
  'demographics.instagram.countries:iso.NG',
  'demographics.instagram.countries:iso.NU',
  'demographics.instagram.countries:iso.NF',
  'demographics.instagram.countries:iso.MP',
  'demographics.instagram.countries:iso.NO',
  'demographics.instagram.countries:iso.OM',
  'demographics.instagram.countries:iso.PK',
  'demographics.instagram.countries:iso.PW',
  'demographics.instagram.countries:iso.PS',
  'demographics.instagram.countries:iso.PA',
  'demographics.instagram.countries:iso.PG',
  'demographics.instagram.countries:iso.PY',
  'demographics.instagram.countries:iso.PE',
  'demographics.instagram.countries:iso.PH',
  'demographics.instagram.countries:iso.PN',
  'demographics.instagram.countries:iso.PL',
  'demographics.instagram.countries:iso.PT',
  'demographics.instagram.countries:iso.PR',
  'demographics.instagram.countries:iso.QA',
  'demographics.instagram.countries:iso.RE',
  'demographics.instagram.countries:iso.RO',
  'demographics.instagram.countries:iso.RU',
  'demographics.instagram.countries:iso.RW',
  'demographics.instagram.countries:iso.BL',
  'demographics.instagram.countries:iso.SH',
  'demographics.instagram.countries:iso.KN',
  'demographics.instagram.countries:iso.LC',
  'demographics.instagram.countries:iso.MF',
  'demographics.instagram.countries:iso.PM',
  'demographics.instagram.countries:iso.VC',
  'demographics.instagram.countries:iso.WS',
  'demographics.instagram.countries:iso.SM',
  'demographics.instagram.countries:iso.ST',
  'demographics.instagram.countries:iso.SA',
  'demographics.instagram.countries:iso.SN',
  'demographics.instagram.countries:iso.RS',
  'demographics.instagram.countries:iso.SC',
  'demographics.instagram.countries:iso.SL',
  'demographics.instagram.countries:iso.SG',
  'demographics.instagram.countries:iso.SX',
  'demographics.instagram.countries:iso.SK',
  'demographics.instagram.countries:iso.SI',
  'demographics.instagram.countries:iso.SB',
  'demographics.instagram.countries:iso.SO',
  'demographics.instagram.countries:iso.ZA',
  'demographics.instagram.countries:iso.GS',
  'demographics.instagram.countries:iso.KR',
  'demographics.instagram.countries:iso.SS',
  'demographics.instagram.countries:iso.ES',
  'demographics.instagram.countries:iso.LK',
  'demographics.instagram.countries:iso.SD',
  'demographics.instagram.countries:iso.SR',
  'demographics.instagram.countries:iso.SJ',
  'demographics.instagram.countries:iso.SZ',
  'demographics.instagram.countries:iso.SE',
  'demographics.instagram.countries:iso.CH',
  'demographics.instagram.countries:iso.SY',
  'demographics.instagram.countries:iso.TW',
  'demographics.instagram.countries:iso.TJ',
  'demographics.instagram.countries:iso.TZ',
  'demographics.instagram.countries:iso.TH',
  'demographics.instagram.countries:iso.TL',
  'demographics.instagram.countries:iso.TG',
  'demographics.instagram.countries:iso.TK',
  'demographics.instagram.countries:iso.TO',
  'demographics.instagram.countries:iso.TT',
  'demographics.instagram.countries:iso.TN',
  'demographics.instagram.countries:iso.TR',
  'demographics.instagram.countries:iso.TM',
  'demographics.instagram.countries:iso.TC',
  'demographics.instagram.countries:iso.TV',
  'demographics.instagram.countries:iso.UG',
  'demographics.instagram.countries:iso.UA',
  'demographics.instagram.countries:iso.AE',
  'demographics.instagram.countries:iso.GB',
  'demographics.instagram.countries:iso.US',
  'demographics.instagram.countries:iso.UM',
  'demographics.instagram.countries:iso.UY',
  'demographics.instagram.countries:iso.UZ',
  'demographics.instagram.countries:iso.VU',
  'demographics.instagram.countries:iso.VE',
  'demographics.instagram.countries:iso.VN',
  'demographics.instagram.countries:iso.VG',
  'demographics.instagram.countries:iso.VI',
  'demographics.instagram.countries:iso.WF',
  'demographics.instagram.countries:iso.EH',
  'demographics.instagram.countries:iso.YE',
  'demographics.instagram.countries:iso.ZM',
  'demographics.instagram.countries:iso.ZW',
  'demographics.youtube.countries:iso.AF',
  'demographics.youtube.countries:iso.AX',
  'demographics.youtube.countries:iso.AL',
  'demographics.youtube.countries:iso.DZ',
  'demographics.youtube.countries:iso.AS',
  'demographics.youtube.countries:iso.AD',
  'demographics.youtube.countries:iso.AO',
  'demographics.youtube.countries:iso.AI',
  'demographics.youtube.countries:iso.AQ',
  'demographics.youtube.countries:iso.AG',
  'demographics.youtube.countries:iso.AR',
  'demographics.youtube.countries:iso.AM',
  'demographics.youtube.countries:iso.AW',
  'demographics.youtube.countries:iso.AU',
  'demographics.youtube.countries:iso.AT',
  'demographics.youtube.countries:iso.AZ',
  'demographics.youtube.countries:iso.BS',
  'demographics.youtube.countries:iso.BH',
  'demographics.youtube.countries:iso.BD',
  'demographics.youtube.countries:iso.BB',
  'demographics.youtube.countries:iso.BY',
  'demographics.youtube.countries:iso.BE',
  'demographics.youtube.countries:iso.BZ',
  'demographics.youtube.countries:iso.BJ',
  'demographics.youtube.countries:iso.BM',
  'demographics.youtube.countries:iso.BT',
  'demographics.youtube.countries:iso.BO',
  'demographics.youtube.countries:iso.BQ',
  'demographics.youtube.countries:iso.BA',
  'demographics.youtube.countries:iso.BW',
  'demographics.youtube.countries:iso.BV',
  'demographics.youtube.countries:iso.BR',
  'demographics.youtube.countries:iso.IO',
  'demographics.youtube.countries:iso.BN',
  'demographics.youtube.countries:iso.BG',
  'demographics.youtube.countries:iso.BF',
  'demographics.youtube.countries:iso.BI',
  'demographics.youtube.countries:iso.KH',
  'demographics.youtube.countries:iso.CM',
  'demographics.youtube.countries:iso.CA',
  'demographics.youtube.countries:iso.CV',
  'demographics.youtube.countries:iso.KY',
  'demographics.youtube.countries:iso.CF',
  'demographics.youtube.countries:iso.TD',
  'demographics.youtube.countries:iso.CL',
  'demographics.youtube.countries:iso.CN',
  'demographics.youtube.countries:iso.CX',
  'demographics.youtube.countries:iso.CC',
  'demographics.youtube.countries:iso.CO',
  'demographics.youtube.countries:iso.KM',
  'demographics.youtube.countries:iso.CG',
  'demographics.youtube.countries:iso.CD',
  'demographics.youtube.countries:iso.CK',
  'demographics.youtube.countries:iso.CR',
  'demographics.youtube.countries:iso.HR',
  'demographics.youtube.countries:iso.CU',
  'demographics.youtube.countries:iso.CW',
  'demographics.youtube.countries:iso.CY',
  'demographics.youtube.countries:iso.CZ',
  'demographics.youtube.countries:iso.DK',
  'demographics.youtube.countries:iso.DJ',
  'demographics.youtube.countries:iso.DM',
  'demographics.youtube.countries:iso.DO',
  'demographics.youtube.countries:iso.EC',
  'demographics.youtube.countries:iso.EG',
  'demographics.youtube.countries:iso.SV',
  'demographics.youtube.countries:iso.GQ',
  'demographics.youtube.countries:iso.ER',
  'demographics.youtube.countries:iso.EE',
  'demographics.youtube.countries:iso.ET',
  'demographics.youtube.countries:iso.FK',
  'demographics.youtube.countries:iso.FO',
  'demographics.youtube.countries:iso.FJ',
  'demographics.youtube.countries:iso.FI',
  'demographics.youtube.countries:iso.FR',
  'demographics.youtube.countries:iso.GF',
  'demographics.youtube.countries:iso.PF',
  'demographics.youtube.countries:iso.TF',
  'demographics.youtube.countries:iso.GA',
  'demographics.youtube.countries:iso.GM',
  'demographics.youtube.countries:iso.GE',
  'demographics.youtube.countries:iso.DE',
  'demographics.youtube.countries:iso.GH',
  'demographics.youtube.countries:iso.GI',
  'demographics.youtube.countries:iso.GR',
  'demographics.youtube.countries:iso.GL',
  'demographics.youtube.countries:iso.GD',
  'demographics.youtube.countries:iso.GP',
  'demographics.youtube.countries:iso.GU',
  'demographics.youtube.countries:iso.GT',
  'demographics.youtube.countries:iso.GG',
  'demographics.youtube.countries:iso.GN',
  'demographics.youtube.countries:iso.GW',
  'demographics.youtube.countries:iso.GY',
  'demographics.youtube.countries:iso.HT',
  'demographics.youtube.countries:iso.HM',
  'demographics.youtube.countries:iso.VA',
  'demographics.youtube.countries:iso.HN',
  'demographics.youtube.countries:iso.HK',
  'demographics.youtube.countries:iso.HU',
  'demographics.youtube.countries:iso.IS',
  'demographics.youtube.countries:iso.IN',
  'demographics.youtube.countries:iso.ID',
  'demographics.youtube.countries:iso.IR',
  'demographics.youtube.countries:iso.IQ',
  'demographics.youtube.countries:iso.IE',
  'demographics.youtube.countries:iso.IM',
  'demographics.youtube.countries:iso.IL',
  'demographics.youtube.countries:iso.IT',
  'demographics.youtube.countries:iso.CI',
  'demographics.youtube.countries:iso.JM',
  'demographics.youtube.countries:iso.JP',
  'demographics.youtube.countries:iso.JE',
  'demographics.youtube.countries:iso.JO',
  'demographics.youtube.countries:iso.KZ',
  'demographics.youtube.countries:iso.KE',
  'demographics.youtube.countries:iso.KI',
  'demographics.youtube.countries:iso.KW',
  'demographics.youtube.countries:iso.KG',
  'demographics.youtube.countries:iso.LA',
  'demographics.youtube.countries:iso.LV',
  'demographics.youtube.countries:iso.LB',
  'demographics.youtube.countries:iso.LS',
  'demographics.youtube.countries:iso.LR',
  'demographics.youtube.countries:iso.LY',
  'demographics.youtube.countries:iso.LI',
  'demographics.youtube.countries:iso.LT',
  'demographics.youtube.countries:iso.LU',
  'demographics.youtube.countries:iso.MO',
  'demographics.youtube.countries:iso.MK',
  'demographics.youtube.countries:iso.MG',
  'demographics.youtube.countries:iso.MW',
  'demographics.youtube.countries:iso.MY',
  'demographics.youtube.countries:iso.MV',
  'demographics.youtube.countries:iso.ML',
  'demographics.youtube.countries:iso.MT',
  'demographics.youtube.countries:iso.MH',
  'demographics.youtube.countries:iso.MQ',
  'demographics.youtube.countries:iso.MR',
  'demographics.youtube.countries:iso.MU',
  'demographics.youtube.countries:iso.YT',
  'demographics.youtube.countries:iso.MX',
  'demographics.youtube.countries:iso.FM',
  'demographics.youtube.countries:iso.MD',
  'demographics.youtube.countries:iso.MC',
  'demographics.youtube.countries:iso.MN',
  'demographics.youtube.countries:iso.ME',
  'demographics.youtube.countries:iso.MS',
  'demographics.youtube.countries:iso.MA',
  'demographics.youtube.countries:iso.MZ',
  'demographics.youtube.countries:iso.MM',
  'demographics.youtube.countries:iso.NA',
  'demographics.youtube.countries:iso.NR',
  'demographics.youtube.countries:iso.NP',
  'demographics.youtube.countries:iso.NL',
  'demographics.youtube.countries:iso.NC',
  'demographics.youtube.countries:iso.NZ',
  'demographics.youtube.countries:iso.NI',
  'demographics.youtube.countries:iso.NE',
  'demographics.youtube.countries:iso.NG',
  'demographics.youtube.countries:iso.NU',
  'demographics.youtube.countries:iso.NF',
  'demographics.youtube.countries:iso.MP',
  'demographics.youtube.countries:iso.NO',
  'demographics.youtube.countries:iso.OM',
  'demographics.youtube.countries:iso.PK',
  'demographics.youtube.countries:iso.PW',
  'demographics.youtube.countries:iso.PS',
  'demographics.youtube.countries:iso.PA',
  'demographics.youtube.countries:iso.PG',
  'demographics.youtube.countries:iso.PY',
  'demographics.youtube.countries:iso.PE',
  'demographics.youtube.countries:iso.PH',
  'demographics.youtube.countries:iso.PN',
  'demographics.youtube.countries:iso.PL',
  'demographics.youtube.countries:iso.PT',
  'demographics.youtube.countries:iso.PR',
  'demographics.youtube.countries:iso.QA',
  'demographics.youtube.countries:iso.RE',
  'demographics.youtube.countries:iso.RO',
  'demographics.youtube.countries:iso.RU',
  'demographics.youtube.countries:iso.RW',
  'demographics.youtube.countries:iso.BL',
  'demographics.youtube.countries:iso.SH',
  'demographics.youtube.countries:iso.KN',
  'demographics.youtube.countries:iso.LC',
  'demographics.youtube.countries:iso.MF',
  'demographics.youtube.countries:iso.PM',
  'demographics.youtube.countries:iso.VC',
  'demographics.youtube.countries:iso.WS',
  'demographics.youtube.countries:iso.SM',
  'demographics.youtube.countries:iso.ST',
  'demographics.youtube.countries:iso.SA',
  'demographics.youtube.countries:iso.SN',
  'demographics.youtube.countries:iso.RS',
  'demographics.youtube.countries:iso.SC',
  'demographics.youtube.countries:iso.SL',
  'demographics.youtube.countries:iso.SG',
  'demographics.youtube.countries:iso.SX',
  'demographics.youtube.countries:iso.SK',
  'demographics.youtube.countries:iso.SI',
  'demographics.youtube.countries:iso.SB',
  'demographics.youtube.countries:iso.SO',
  'demographics.youtube.countries:iso.ZA',
  'demographics.youtube.countries:iso.GS',
  'demographics.youtube.countries:iso.KR',
  'demographics.youtube.countries:iso.SS',
  'demographics.youtube.countries:iso.ES',
  'demographics.youtube.countries:iso.LK',
  'demographics.youtube.countries:iso.SD',
  'demographics.youtube.countries:iso.SR',
  'demographics.youtube.countries:iso.SJ',
  'demographics.youtube.countries:iso.SZ',
  'demographics.youtube.countries:iso.SE',
  'demographics.youtube.countries:iso.CH',
  'demographics.youtube.countries:iso.SY',
  'demographics.youtube.countries:iso.TW',
  'demographics.youtube.countries:iso.TJ',
  'demographics.youtube.countries:iso.TZ',
  'demographics.youtube.countries:iso.TH',
  'demographics.youtube.countries:iso.TL',
  'demographics.youtube.countries:iso.TG',
  'demographics.youtube.countries:iso.TK',
  'demographics.youtube.countries:iso.TO',
  'demographics.youtube.countries:iso.TT',
  'demographics.youtube.countries:iso.TN',
  'demographics.youtube.countries:iso.TR',
  'demographics.youtube.countries:iso.TM',
  'demographics.youtube.countries:iso.TC',
  'demographics.youtube.countries:iso.TV',
  'demographics.youtube.countries:iso.UG',
  'demographics.youtube.countries:iso.UA',
  'demographics.youtube.countries:iso.AE',
  'demographics.youtube.countries:iso.GB',
  'demographics.youtube.countries:iso.US',
  'demographics.youtube.countries:iso.UM',
  'demographics.youtube.countries:iso.UY',
  'demographics.youtube.countries:iso.UZ',
  'demographics.youtube.countries:iso.VU',
  'demographics.youtube.countries:iso.VE',
  'demographics.youtube.countries:iso.VN',
  'demographics.youtube.countries:iso.VG',
  'demographics.youtube.countries:iso.VI',
  'demographics.youtube.countries:iso.WF',
  'demographics.youtube.countries:iso.EH',
  'demographics.youtube.countries:iso.YE',
  'demographics.youtube.countries:iso.ZM',
  'demographics.youtube.countries:iso.ZW',
  'demographics.tiktok.countries:iso.AF',
  'demographics.tiktok.countries:iso.AX',
  'demographics.tiktok.countries:iso.AL',
  'demographics.tiktok.countries:iso.DZ',
  'demographics.tiktok.countries:iso.AS',
  'demographics.tiktok.countries:iso.AD',
  'demographics.tiktok.countries:iso.AO',
  'demographics.tiktok.countries:iso.AI',
  'demographics.tiktok.countries:iso.AQ',
  'demographics.tiktok.countries:iso.AG',
  'demographics.tiktok.countries:iso.AR',
  'demographics.tiktok.countries:iso.AM',
  'demographics.tiktok.countries:iso.AW',
  'demographics.tiktok.countries:iso.AU',
  'demographics.tiktok.countries:iso.AT',
  'demographics.tiktok.countries:iso.AZ',
  'demographics.tiktok.countries:iso.BS',
  'demographics.tiktok.countries:iso.BH',
  'demographics.tiktok.countries:iso.BD',
  'demographics.tiktok.countries:iso.BB',
  'demographics.tiktok.countries:iso.BY',
  'demographics.tiktok.countries:iso.BE',
  'demographics.tiktok.countries:iso.BZ',
  'demographics.tiktok.countries:iso.BJ',
  'demographics.tiktok.countries:iso.BM',
  'demographics.tiktok.countries:iso.BT',
  'demographics.tiktok.countries:iso.BO',
  'demographics.tiktok.countries:iso.BQ',
  'demographics.tiktok.countries:iso.BA',
  'demographics.tiktok.countries:iso.BW',
  'demographics.tiktok.countries:iso.BV',
  'demographics.tiktok.countries:iso.BR',
  'demographics.tiktok.countries:iso.IO',
  'demographics.tiktok.countries:iso.BN',
  'demographics.tiktok.countries:iso.BG',
  'demographics.tiktok.countries:iso.BF',
  'demographics.tiktok.countries:iso.BI',
  'demographics.tiktok.countries:iso.KH',
  'demographics.tiktok.countries:iso.CM',
  'demographics.tiktok.countries:iso.CA',
  'demographics.tiktok.countries:iso.CV',
  'demographics.tiktok.countries:iso.KY',
  'demographics.tiktok.countries:iso.CF',
  'demographics.tiktok.countries:iso.TD',
  'demographics.tiktok.countries:iso.CL',
  'demographics.tiktok.countries:iso.CN',
  'demographics.tiktok.countries:iso.CX',
  'demographics.tiktok.countries:iso.CC',
  'demographics.tiktok.countries:iso.CO',
  'demographics.tiktok.countries:iso.KM',
  'demographics.tiktok.countries:iso.CG',
  'demographics.tiktok.countries:iso.CD',
  'demographics.tiktok.countries:iso.CK',
  'demographics.tiktok.countries:iso.CR',
  'demographics.tiktok.countries:iso.HR',
  'demographics.tiktok.countries:iso.CU',
  'demographics.tiktok.countries:iso.CW',
  'demographics.tiktok.countries:iso.CY',
  'demographics.tiktok.countries:iso.CZ',
  'demographics.tiktok.countries:iso.DK',
  'demographics.tiktok.countries:iso.DJ',
  'demographics.tiktok.countries:iso.DM',
  'demographics.tiktok.countries:iso.DO',
  'demographics.tiktok.countries:iso.EC',
  'demographics.tiktok.countries:iso.EG',
  'demographics.tiktok.countries:iso.SV',
  'demographics.tiktok.countries:iso.GQ',
  'demographics.tiktok.countries:iso.ER',
  'demographics.tiktok.countries:iso.EE',
  'demographics.tiktok.countries:iso.ET',
  'demographics.tiktok.countries:iso.FK',
  'demographics.tiktok.countries:iso.FO',
  'demographics.tiktok.countries:iso.FJ',
  'demographics.tiktok.countries:iso.FI',
  'demographics.tiktok.countries:iso.FR',
  'demographics.tiktok.countries:iso.GF',
  'demographics.tiktok.countries:iso.PF',
  'demographics.tiktok.countries:iso.TF',
  'demographics.tiktok.countries:iso.GA',
  'demographics.tiktok.countries:iso.GM',
  'demographics.tiktok.countries:iso.GE',
  'demographics.tiktok.countries:iso.DE',
  'demographics.tiktok.countries:iso.GH',
  'demographics.tiktok.countries:iso.GI',
  'demographics.tiktok.countries:iso.GR',
  'demographics.tiktok.countries:iso.GL',
  'demographics.tiktok.countries:iso.GD',
  'demographics.tiktok.countries:iso.GP',
  'demographics.tiktok.countries:iso.GU',
  'demographics.tiktok.countries:iso.GT',
  'demographics.tiktok.countries:iso.GG',
  'demographics.tiktok.countries:iso.GN',
  'demographics.tiktok.countries:iso.GW',
  'demographics.tiktok.countries:iso.GY',
  'demographics.tiktok.countries:iso.HT',
  'demographics.tiktok.countries:iso.HM',
  'demographics.tiktok.countries:iso.VA',
  'demographics.tiktok.countries:iso.HN',
  'demographics.tiktok.countries:iso.HK',
  'demographics.tiktok.countries:iso.HU',
  'demographics.tiktok.countries:iso.IS',
  'demographics.tiktok.countries:iso.IN',
  'demographics.tiktok.countries:iso.ID',
  'demographics.tiktok.countries:iso.IR',
  'demographics.tiktok.countries:iso.IQ',
  'demographics.tiktok.countries:iso.IE',
  'demographics.tiktok.countries:iso.IM',
  'demographics.tiktok.countries:iso.IL',
  'demographics.tiktok.countries:iso.IT',
  'demographics.tiktok.countries:iso.CI',
  'demographics.tiktok.countries:iso.JM',
  'demographics.tiktok.countries:iso.JP',
  'demographics.tiktok.countries:iso.JE',
  'demographics.tiktok.countries:iso.JO',
  'demographics.tiktok.countries:iso.KZ',
  'demographics.tiktok.countries:iso.KE',
  'demographics.tiktok.countries:iso.KI',
  'demographics.tiktok.countries:iso.KW',
  'demographics.tiktok.countries:iso.KG',
  'demographics.tiktok.countries:iso.LA',
  'demographics.tiktok.countries:iso.LV',
  'demographics.tiktok.countries:iso.LB',
  'demographics.tiktok.countries:iso.LS',
  'demographics.tiktok.countries:iso.LR',
  'demographics.tiktok.countries:iso.LY',
  'demographics.tiktok.countries:iso.LI',
  'demographics.tiktok.countries:iso.LT',
  'demographics.tiktok.countries:iso.LU',
  'demographics.tiktok.countries:iso.MO',
  'demographics.tiktok.countries:iso.MK',
  'demographics.tiktok.countries:iso.MG',
  'demographics.tiktok.countries:iso.MW',
  'demographics.tiktok.countries:iso.MY',
  'demographics.tiktok.countries:iso.MV',
  'demographics.tiktok.countries:iso.ML',
  'demographics.tiktok.countries:iso.MT',
  'demographics.tiktok.countries:iso.MH',
  'demographics.tiktok.countries:iso.MQ',
  'demographics.tiktok.countries:iso.MR',
  'demographics.tiktok.countries:iso.MU',
  'demographics.tiktok.countries:iso.YT',
  'demographics.tiktok.countries:iso.MX',
  'demographics.tiktok.countries:iso.FM',
  'demographics.tiktok.countries:iso.MD',
  'demographics.tiktok.countries:iso.MC',
  'demographics.tiktok.countries:iso.MN',
  'demographics.tiktok.countries:iso.ME',
  'demographics.tiktok.countries:iso.MS',
  'demographics.tiktok.countries:iso.MA',
  'demographics.tiktok.countries:iso.MZ',
  'demographics.tiktok.countries:iso.MM',
  'demographics.tiktok.countries:iso.NA',
  'demographics.tiktok.countries:iso.NR',
  'demographics.tiktok.countries:iso.NP',
  'demographics.tiktok.countries:iso.NL',
  'demographics.tiktok.countries:iso.NC',
  'demographics.tiktok.countries:iso.NZ',
  'demographics.tiktok.countries:iso.NI',
  'demographics.tiktok.countries:iso.NE',
  'demographics.tiktok.countries:iso.NG',
  'demographics.tiktok.countries:iso.NU',
  'demographics.tiktok.countries:iso.NF',
  'demographics.tiktok.countries:iso.MP',
  'demographics.tiktok.countries:iso.NO',
  'demographics.tiktok.countries:iso.OM',
  'demographics.tiktok.countries:iso.PK',
  'demographics.tiktok.countries:iso.PW',
  'demographics.tiktok.countries:iso.PS',
  'demographics.tiktok.countries:iso.PA',
  'demographics.tiktok.countries:iso.PG',
  'demographics.tiktok.countries:iso.PY',
  'demographics.tiktok.countries:iso.PE',
  'demographics.tiktok.countries:iso.PH',
  'demographics.tiktok.countries:iso.PN',
  'demographics.tiktok.countries:iso.PL',
  'demographics.tiktok.countries:iso.PT',
  'demographics.tiktok.countries:iso.PR',
  'demographics.tiktok.countries:iso.QA',
  'demographics.tiktok.countries:iso.RE',
  'demographics.tiktok.countries:iso.RO',
  'demographics.tiktok.countries:iso.RU',
  'demographics.tiktok.countries:iso.RW',
  'demographics.tiktok.countries:iso.BL',
  'demographics.tiktok.countries:iso.SH',
  'demographics.tiktok.countries:iso.KN',
  'demographics.tiktok.countries:iso.LC',
  'demographics.tiktok.countries:iso.MF',
  'demographics.tiktok.countries:iso.PM',
  'demographics.tiktok.countries:iso.VC',
  'demographics.tiktok.countries:iso.WS',
  'demographics.tiktok.countries:iso.SM',
  'demographics.tiktok.countries:iso.ST',
  'demographics.tiktok.countries:iso.SA',
  'demographics.tiktok.countries:iso.SN',
  'demographics.tiktok.countries:iso.RS',
  'demographics.tiktok.countries:iso.SC',
  'demographics.tiktok.countries:iso.SL',
  'demographics.tiktok.countries:iso.SG',
  'demographics.tiktok.countries:iso.SX',
  'demographics.tiktok.countries:iso.SK',
  'demographics.tiktok.countries:iso.SI',
  'demographics.tiktok.countries:iso.SB',
  'demographics.tiktok.countries:iso.SO',
  'demographics.tiktok.countries:iso.ZA',
  'demographics.tiktok.countries:iso.GS',
  'demographics.tiktok.countries:iso.KR',
  'demographics.tiktok.countries:iso.SS',
  'demographics.tiktok.countries:iso.ES',
  'demographics.tiktok.countries:iso.LK',
  'demographics.tiktok.countries:iso.SD',
  'demographics.tiktok.countries:iso.SR',
  'demographics.tiktok.countries:iso.SJ',
  'demographics.tiktok.countries:iso.SZ',
  'demographics.tiktok.countries:iso.SE',
  'demographics.tiktok.countries:iso.CH',
  'demographics.tiktok.countries:iso.SY',
  'demographics.tiktok.countries:iso.TW',
  'demographics.tiktok.countries:iso.TJ',
  'demographics.tiktok.countries:iso.TZ',
  'demographics.tiktok.countries:iso.TH',
  'demographics.tiktok.countries:iso.TL',
  'demographics.tiktok.countries:iso.TG',
  'demographics.tiktok.countries:iso.TK',
  'demographics.tiktok.countries:iso.TO',
  'demographics.tiktok.countries:iso.TT',
  'demographics.tiktok.countries:iso.TN',
  'demographics.tiktok.countries:iso.TR',
  'demographics.tiktok.countries:iso.TM',
  'demographics.tiktok.countries:iso.TC',
  'demographics.tiktok.countries:iso.TV',
  'demographics.tiktok.countries:iso.UG',
  'demographics.tiktok.countries:iso.UA',
  'demographics.tiktok.countries:iso.AE',
  'demographics.tiktok.countries:iso.GB',
  'demographics.tiktok.countries:iso.US',
  'demographics.tiktok.countries:iso.UM',
  'demographics.tiktok.countries:iso.UY',
  'demographics.tiktok.countries:iso.UZ',
  'demographics.tiktok.countries:iso.VU',
  'demographics.tiktok.countries:iso.VE',
  'demographics.tiktok.countries:iso.VN',
  'demographics.tiktok.countries:iso.VG',
  'demographics.tiktok.countries:iso.VI',
  'demographics.tiktok.countries:iso.WF',
  'demographics.tiktok.countries:iso.EH',
  'demographics.tiktok.countries:iso.YE',
  'demographics.tiktok.countries:iso.ZM',
  'demographics.tiktok.countries:iso.ZW',
];

export const ALLOWED_CREATOR_SEARCH_BY_FIELDS = [
  'bio_agency',
  'category_agency',
  'email',
  'first_name',
  'full_name',
  'id',
  'last_name',
  'location.full_address',
  'location.country',
  'location.city',
  'name',
  'notes',
  'platforms.instagram.handle',
  'platforms.snapchat.display_name',
  'platforms.snapchat.username',
  'platforms.tiktok.display_name',
  'platforms.tiktok.handle',
  'platforms.youtube.handle',
  'platforms.youtube.name',
  'slug',
  // TODO: Uncomment these once we know how to highlight those fields in the search results
  // 'platforms.instagram.biography',
  // 'platforms.snapchat.description',
  // 'platforms.youtube.description',
];

export const NAME_OR_HANDLE_SEARCH_BY_FIELDS = [
  'first_name',
  'last_name',
  'full_name',
  'platforms.instagram.handle',
  'platforms.snapchat.username',
  'platforms.tiktok.handle',
  'platforms.youtube.handle',
];
